import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { X, Cookie } from 'lucide-react';

export const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    if (!cookiesAccepted) {
      setShowBanner(true);
    }
    // For testing purposes, always show in development
    // Remove this line for production
    if (process.env.NODE_ENV === 'development') {
      localStorage.removeItem('cookiesAccepted');
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowBanner(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[#004534] border-t-4 border-[#f97316] shadow-2xl z-50 animate-slide-up">
      <div className="container mx-auto px-4 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-start space-x-4 flex-1">
            <Cookie className="h-8 w-8 text-[#f97316] flex-shrink-0 mt-1" />
            <div className="text-white">
              <h3 className="text-lg font-bold mb-2">Uso de Cookies</h3>
              <p className="text-green-100 text-sm leading-relaxed">
                Utilizamos cookies técnicas y de análisis para mejorar tu experiencia de navegación. 
                Al continuar navegando, aceptas el uso de cookies según nuestra{' '}
                <a 
                  href="/politica-cookies" 
                  className="text-[#f97316] hover:text-orange-300 underline font-medium"
                >
                  Política de Cookies
                </a>
                .
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-3 flex-shrink-0">
            <Button
              onClick={rejectCookies}
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-[#004534] px-4 py-2 rounded-full font-medium"
            >
              Rechazar
            </Button>
            <Button
              onClick={acceptCookies}
              className="bg-[#f97316] hover:bg-[#ea580c] text-white px-6 py-2 rounded-full font-medium transition-all transform hover:scale-105"
            >
              Aceptar Cookies
            </Button>
            <button
              onClick={rejectCookies}
              className="text-white hover:text-gray-300 p-2 transition-colors"
              title="Cerrar"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};